import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { MainViewService } from '@modules/common/services/main-view.service';
import { SpaceContextStore } from '@modules/common/services/SpaceContextStore';
import { SpaceType } from '@sharedlib/common/types/SpaceType';
import { distinctUntilChanged, map } from 'rxjs';

@Injectable()
export class NotesWorkspaceContextService {
  private readonly context = inject(SpaceContextStore);
  private readonly mainView = inject(MainViewService);
  private readonly route = inject(ActivatedRoute);

  public constructor() {
    this.mainView.clearMainView();
    this.route.paramMap
      .pipe(
        map((params) => params.get('spaceId')),
        distinctUntilChanged(),
        takeUntilDestroyed(),
      )
      .subscribe((spaceId) => {
        if (spaceId) {
          if (this.context.contextId() !== spaceId) {
            this.mainView.clearMainView();
          }
          this.context.setConfirmedContext(SpaceType.SHARED_SPACE, spaceId);
        }
      });
    inject(DestroyRef).onDestroy(() => this.mainView.clearMainView());
  }
}
